// extracted by mini-css-extract-plugin
export default {"wrapper":"Card_wrapper__fy3FS","card":"Card_card__ZZFfT","banner":"Card_banner__YzifC","pill":"Card_pill__5MhxH","titleWrapper":"Card_titleWrapper__pdqdb","chip":"Card_chip__QLLME"};